<template>
  <div v-if="resource">
    <div v-if="resource.master_name !== null && (resource.type === 'boolean' || resource.name === 'sex_id' || resource.type === 'radio')"
         class="d-flex flex-wrap">
      <div v-for="item in addMasterNameDefault(itemJob, master, resource.type)" :key="item.id" class="mr-2">
        <label class="setting_form_radio_label" v-if="item.show">
          <input
              type="radio"
              v-model="resource.default_value"
              :id="item.id"
              :value="item"
              :disabled="isDisableEditing"
          />
          <span class="setting_form_radio_text" :for="item.id" v-if="item.choiceDisplayName">
            {{ item.choiceDisplayName }}
          </span>
          <span class="setting_form_radio_text" :for="item.id" v-else>
            {{ item.choiceName }}
          </span>
        </label>
      </div>
    </div>

    <div class="d-flex flex-wrap setting_unit_form"
         v-else-if="resource.master_name !== null && (resource.type === 'single_select' || resource.type === 'select') && resource.name !== 'sex_id'">
      <div class="setting_unit_form">
        <div class="setting_form_select_wrapper" v-if="master && master.length > 0">
          <select v-model="resource.default_value" class="setting_form_select" :disabled="isDisableEditing">
            <option value="">---</option>
            <option v-for="item in master.filter((item) => item.show)" v-bind:value="item" :key="item.id">
              <span v-if="item.choiceDisplayName">
                {{ item.choiceDisplayName }}
              </span>
              <span v-else>
                {{ item.choiceName }}
              </span>
            </option>
          </select>
        </div>
      </div>
    </div>

    <div v-else-if="resource.master_name !== null && (resource.type === 'multi_select' || resource.type === 'checkbox')">
      <div v-if="checkTypeOfArray(resource)" class="d-flex flex-wrap">
        <div v-for="item in master" :key="item.id" class="p-2">
          <label class="jobs_form_label ml-2" v-if="item.show">
            <input
              type="checkbox"
              v-model="resource.default_value"
              :id="item.id"
              :value="item"
              :disabled="isDisableEditing"
            />
            <span :for="item.id" v-if="item.choiceDisplayName">
              {{ item.choiceDisplayName }}
            </span>
            <span :for="item.id" v-else>
              {{ item.choiceName }}
            </span>
          </label>
        </div>

        <div v-if="itemJob" class="ml-auto p-2">
          <label class="setting_form_radio_label ml-2">
            <input
                type="radio"
                v-model="resource.multiSelectOption"
                value="1"
            />
            <span class="setting_form_radio_text">
              {{ labelProperties.AND }}
            </span>
          </label>
          <label class="setting_form_radio_label ml-2">
            <input
                type="radio"
                v-model="resource.multiSelectOption"
                :value="undefined"
                checked
            />
            <span class="setting_form_radio_text">
              {{ labelProperties.OR }}
            </span>
          </label>
        </div>
      </div>
    </div>

    <div v-else-if="resource.type === 'textarea'">
      <template v-if="!itemJob">
        <textarea
          class="setting_form_textarea jobs_form_text"
          v-model="resource.default_value"
          :type="resource.type"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="validateStringLengthInput(itemJob, resource)"
        />
      </template>
      <template v-if="itemJob">
        <input
          class="setting_form_text_customize jobs_form_text"
          v-model="resource.default_value"
          type="text"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="validateStringLengthInput(itemJob, resource)"
        />
      </template>
      <span class="setting_range_allow_input" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.WORD_COUNT}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.isMinLengthError">{{resource.min_length}}{{messagesProperties.MIN_LENGTH_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxLengthError">
        <template v-if="resource.max_length">{{ resource.max_length }}</template>
        <template v-if="!resource.max_length">{{ messagesProperties.MAX_LENGTH_INPUT_TEXT_AREA }}</template>
        {{ messagesProperties.MAX_LENGTH_ERROR }}</p>
    </div>

    <div v-else-if="resource.type === 'datetime'">
      <div v-if="itemJob" class="setting_form_input_from_to">
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_from"
            format="YYYY/MM/DD HH:mm"
            type="datetime"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <div class="date_form_join_string">
          <font style="vertical-align: inherit">~</font>
        </div>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_to"
            format="YYYY/MM/DD HH:mm"
            type="datetime"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
      <div v-else>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value"
            format="YYYY/MM/DD HH:mm"
            type="datetime"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
    </div>

    <div v-else-if="resource.type === 'time'">
      <div v-if="itemJob" class="setting_form_input_from_to">
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_from"
            format="HH:mm"
            type="time"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <div class="date_form_join_string">
          <font style="vertical-align: inherit">~</font>
        </div>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_to"
            format="HH:mm"
            type="time"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
      <div v-else>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value"
            format="HH:mm"
            type="time"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
    </div>

    <div v-else-if="resource.type === 'date' && resource.name !== 'birth_date'">
      <div v-if="itemJob" class="setting_form_input_from_to">
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_from"
            format="YYYY/MM/DD"
            type="date"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <div class="date_form_join_string">
          <font style="vertical-align: inherit">~</font>
        </div>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_to"
            format="YYYY/MM/DD"
            type="date"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
      <div v-else>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value"
            format="YYYY/MM/DD"
            type="date"
            :lang="jp"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
    </div>

    <div v-else-if="resource.type === 'ym'">
      <div v-if="itemJob" class="setting_form_input_from_to">
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_from"
            format="YYYY/MM"
            type="month"
            :lang="jp"
            :disabled="isDisableEditing"
            default-panel="month"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <div class="date_form_join_string">
          <font style="vertical-align: inherit">~</font>
        </div>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value_to"
            format="YYYY/MM"
            type="month"
            :lang="jp"
            :disabled="isDisableEditing"
            default-panel="month"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
      <div v-else>
        <DatePicker
            class="disabled-setting"
            v-model="resource.default_value"
            format="YYYY/MM"
            type="month"
            :lang="jp"
            :disabled="isDisableEditing"
            default-panel="month"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
      </div>
    </div>

    <div v-else-if="resource.name === 'birth_date' && resource.type === 'date'">
      <div class="input-group">
        <input
            type="number"
            id="year"
            class="setting_form_text_customize input-date jobs_form_text"
            min="1900"
            max="5000"
            :value="year"
            :disabled="isDisableEditing"
            @change="setYearToDefaultValue(resource, $event.target.value)"
        />
        <label for="year" class="bold ml-3 mr-3 mt-2">
          {{ labelsProperties.YEAR }}
        </label>
        <input
            type="number"
            class="setting_form_text_customize input-date jobs_form_text"
            id="month"
            min="1"
            max="12"
            :value="month"
            :disabled="isDisableEditing"
            @change="setMonthToDefaultValue(resource, $event.target.value)"
        />
        <label for="month" class="bold ml-3 mr-3 mt-2">
          {{ labelsProperties.MONTH }}
        </label>
        <input
            type="number"
            class="setting_form_text_customize input-date jobs_form_text"
            id="day"
            min="1"
            max="31"
            :value="day"
            :disabled="isDisableEditing"
            @change="setDateToDefaultValue(resource, $event.target.value)"
        />
        <label for="day" class="bold ml-3 mr-3 mt-2">
          {{ labelsProperties.DAY }}
        </label>
      </div>
    </div>

    <div v-else-if="resource.type === 'integer' || resource.type === 'calc' || resource.type === 'number'">
      <div v-if="itemJob" class="setting_form_input_from_to jobs_table_form_unit">
        <input
            type="number"
            class="setting_form_text_customize jobs_form_text"
            v-model="resource.default_value_from"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <span v-if="resource.unit" :class="{'label_unit_item_long': resource.unit.length > 5, 'label_unit_item': resource.unit.length <= 5}">{{ resource.unit }}</span>
        <div class="date_form_join_string">
          <font style="vertical-align: inherit">~</font>
        </div>
        <input
            type="number"
            class="setting_form_text_customize jobs_form_text"
            v-model="resource.default_value_to"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
        />
        <span v-if="resource.unit" :class="{'label_unit_item_long': resource.unit.length > 5, 'label_unit_item': resource.unit.length <= 5}">{{ resource.unit }}</span>
      </div>
      <div v-else class="jobs_table_form_unit">
        <input
            type="number"
            class="setting_form_text_customize jobs_form_text"
            v-model="resource.default_value"
            :disabled="isDisableEditing"
            :placeholder="itemName + labelsProperties.PLACE_HOLDER"
            @input="validateNumberInput(itemJob, resource)"
        />
        <span v-if="resource.unit" :class="{'label_unit_item_long': resource.unit.length > 5, 'label_unit_item': resource.unit.length <= 5}">{{ resource.unit }}</span>
      </div>
      <span class="setting_range_allow_input" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.RANGE}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.isMinNumberError">{{resource.min_length}}{{messagesProperties.MIN_NUMBER_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxNumberError">{{resource.max_length}}{{messagesProperties.MAX_NUMBER_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isWrongDecimalPoint">
        {{printf(messagesProperties.WRONG_DECIMAL_POINT, resource.length_step)}}
      </p>
    </div>

    <div v-else-if="resource.type === 'url'">
        <input
          class="setting_form_text_customize jobs_form_text"
          v-model="resource.default_value"
          type="url"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="checkInputURL(itemJob, resource)"
        />
      <span class="setting_range_allow_input" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.WORD_COUNT}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.wrongUrl">{{messagesProperties.WRONG_INPUT_URL}}</p>
      <p class="wrong-input" v-show="resource.isMinLengthError">{{resource.min_length}}{{messagesProperties.MIN_LENGTH_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxLengthError">{{ resource.max_length }}{{ messagesProperties.MAX_LENGTH_ERROR }}</p>
    </div>

    <div v-else-if="resource.type === 'tel'">
        <input
          class="setting_form_text_customize jobs_form_text"
          v-model="resource.default_value"
          type="text"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="checkInputPhone(itemJob, resource)"
        />
      <span class="setting_range_allow_input" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.WORD_COUNT}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.wrongPhone">{{messagesProperties.WRONG_INPUT_PHONE}}</p>
      <p class="wrong-input" v-show="resource.isMinLengthError">{{resource.min_length}}{{messagesProperties.MIN_LENGTH_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxLengthError">{{ resource.max_length }}{{ messagesProperties.MAX_LENGTH_ERROR }}</p>
    </div>

    <div v-else-if="resource.type.includes('mail')">
        <input
          type="text"
          class="setting_form_text_customize jobs_form_text"
          v-model="resource.default_value"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="checkInputEmail(itemJob, resource)"
        />
      <span class="setting_range_allow_input" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.WORD_COUNT}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.wrongEmail">{{messagesProperties.WRONG_INPUT_EMAIL}}</p>
      <p class="wrong-input" v-show="resource.isMinLengthError">{{resource.min_length}}{{messagesProperties.MIN_LENGTH_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxLengthError">{{ resource.max_length }}{{ messagesProperties.MAX_LENGTH_ERROR }}</p>
    </div>

    <div v-else-if="resource.name === 'photo'">
      <div class="entry_uploader_item">
        <div class="entry_uploader_holder">
          <p class="entry_uploader_number"
             v-bind:style="{color: draftColors && draftColors.pageText ? draftColors.pageText : ''}">
            {{ labelsProperties.FILE }}:
          </p>
          <label class="entry_uploader_label img_label ml-3"
                 v-bind:style="[{color: draftColors && draftColors.mainButtonText ? draftColors.mainButtonText : ''}, {backgroundColor: draftColors && draftColors.mainButton ? draftColors.mainButton : ''}, {border: draftColors && draftColors.borderColor ? '1px solid' + draftColors.borderColor : ''}]">
            <input type="file" :disabled="isDisableEditing" ref="fileupload" accept="image/jpeg,image/png,image/gif"
                   @change="handleUploadImage($event.target)"/>
            <span class="entry_uploader_label_name">
              {{ labelsProperties.SELECT_FILE }}
            </span>
          </label>
          <p class="entry_uploader_name" v-if="file && file.name" v-text="file.name"></p>
          <p class="entry_uploader_name is_disabled" v-else>
            {{ labelsProperties.NOT_SELECTED_FILE }}
          </p>
        </div>
        <div class="entry_uploader_delete" @click="handleDeleteImage()">
          <button class="entry_uploader_delete_btn" :class="file.name && !isDisableEditing ? '' : 'is_disabled'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
              <path
                  d="M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"/>
            </svg>
            {{ labelsProperties.DELETE_FILE }}
          </button>
        </div>
      </div>
      <p class="jobs_table_annotation mt-3"
         v-bind:style="{color: draftColors && draftColors.pageText ? draftColors.pageText : ''}">
        {{ labelsProperties.SPECIFY_PHOTO_FORMAT }}
      </p>
      <p v-show="extentionError" class="wrong-input">
        {{ messagesProperties.FILE_EXTENTION_ERROR }}
      </p>
      <p v-show="overSize" class="wrong-input">
        {{ messagesProperties.OVER_SIZE_ERROR }}
      </p>
    </div>

    <div v-else-if="resource.name === 'files'">
      <div class="entry_uploader_item" v-for="(file, index) in files" :key="index">
        <div class="entry_uploader_holder">
          <p class="entry_uploader_number"
             v-bind:style="{color: draftColors && draftColors.pageText ? draftColors.pageText : ''}">
            {{ file.name + (index + 1) }}:
          </p>
          <label class="entry_uploader_label ml-3"
                 v-bind:style="[{color: draftColors && draftColors.mainButtonText ? draftColors.mainButtonText : ''}, {backgroundColor: draftColors && draftColors.mainButton ? draftColors.mainButton : ''}, {border: draftColors && draftColors.borderColor ? '1px solid' + draftColors.borderColor : ''}]">
            <input
                type="file"
                :ref="'attachment-' + index"
                :disabled="isDisableEditing"
                v-on:change="handleUploadFile(index, $event.target.name, $event.target.files)"
            />
            <span class="entry_uploader_label_name">
              {{ file.buttonUpload }}
            </span>
          </label>
          <p class="entry_uploader_name" v-if="file.content && file.content.name">
            {{ file.content.name }}
          </p>
          <p class="entry_uploader_name is_disabled" v-else>
            {{ file.placeholder }}
          </p>
        </div>
        <div class="entry_uploader_delete" @click="deleteFile(index)">
          <button class="entry_uploader_delete_btn" :class="file.content.name && !isDisableEditing ? '' : 'is_disabled'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
              <path
                  d="M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"/>
            </svg>
            {{ file.buttonDelete }}
          </button>
        </div>
      </div>
      <p class="jobs_table_annotation mt-3"
         v-bind:style="{color: draftColors && draftColors.pageText ? draftColors.pageText : ''}">
        {{ labelsProperties.MAX_FILE_SIZE_ALLOW }}
      </p>
      <p v-show="overSize" class="wrong-input">
        {{ messagesProperties.OVER_SIZE_ERROR }}
      </p>
    </div>

    <div v-else>
        <input
          class="setting_form_text_customize jobs_form_text"
          v-model="resource.default_value"
          :type="resource.type"
          :disabled="isDisableEditing"
          :placeholder="itemName + labelsProperties.PLACE_HOLDER"
          @input="validateStringLengthInput(itemJob, resource)"
        />
      <span class="setting_range_allow_input modify_setting_range" v-if="!itemJob && numberOfItem > 1 && (resource.min_length || resource.max_length)">{{labelPopupCustomizeProperties.WORD_COUNT}} {{resource.min_length}} ~ {{resource.max_length}}</span>
      <p class="wrong-input" v-show="resource.isMinLengthError">{{resource.min_length}}{{messagesProperties.MIN_LENGTH_ERROR}}</p>
      <p class="wrong-input" v-show="resource.isMaxLengthError"> 
        <template v-if="resource.max_length">{{ resource.max_length }}</template>
        <template v-if="!resource.max_length && resource.type === 'text'">{{ messagesProperties.MAX_LENGTH_INPUT_TEXT }}</template>
        {{ messagesProperties.MAX_LENGTH_ERROR }}</p>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import {jp} from "vue2-datepicker/locale/ja";
import labelsProperties from "../../../properties/input_component/input-component-labels.json";
import messagesProperties from "../../../properties/input_component/messages.json";
import labelPopupCustomizeProperties from "../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import {printf} from "fast-printf";
import labelProperties from "../../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";

const IMAGE_EXTENTIONS = ".jpeg, .jpg, .png, .ico, .heic, .gif";

export default {
  name: "InputDataComponent",
  components: {DatePicker},
  props: [
    "master",
    "resource",
    "isDisableEditing",
    "year",
    "month",
    "day",
    "draftColors",
    "itemJob",
    "numberOfItem",
    "photo",
    "attachemnts",
    "itemName"
  ],
  data: function () {
    return {
      labelsProperties: labelsProperties,
      labelProperties: labelProperties,
      messagesProperties: messagesProperties,
      labelPopupCustomizeProperties:labelPopupCustomizeProperties,
      birthDate: new Date(),
      file: "",
      jp: jp,
      files: [
        {
          name: labelsProperties.FILE,
          buttonUpload: labelsProperties.SELECT_FILE,
          placeholder: labelsProperties.NOT_SELECTED_FILE,
          buttonDelete: labelsProperties.DELETE_FILE,
          content: "",
        },
        {
          name: labelsProperties.FILE,
          buttonUpload: labelsProperties.SELECT_FILE,
          placeholder: labelsProperties.NOT_SELECTED_FILE,
          buttonDelete: labelsProperties.DELETE_FILE,
          content: "",
        },
        {
          name: labelsProperties.FILE,
          buttonUpload: labelsProperties.SELECT_FILE,
          placeholder: labelsProperties.NOT_SELECTED_FILE,
          buttonDelete: labelsProperties.DELETE_FILE,
          content: "",
        },
      ],
      extentionError: false,
      overSize: false,
      printf: printf
    };
  },
  methods: {
    addMasterNameDefault(itemJob, master, type){
      if(!master) return [];
      if((!itemJob || !type) && master){
        return master;
      }
      if(master && Array.isArray(master)){
        let notHaveDefaultValue = master.find(item => item && (!item.id || item.choiceDisplayName === labelsProperties.DEFAULT_RADIO_OPTION));
        if((type === 'radio' || type === 'boolean') && !notHaveDefaultValue){
          let defaultOption = {id: null, choiceId: null, show: true, choiceDisplayName: labelsProperties.DEFAULT_RADIO_OPTION};
          master.unshift(defaultOption);
          return master;
        }
      }
      return master;
    },

    updatePhoto(){
      this.file = this.photo;
    },

    updateAttachments(){
      this.attachemnts.forEach((attachemnt, index) => {
        this.files[index].content = attachemnt.content;
      });
    },

    handleUploadFile(index, name, file) {
      this.overSize = false;
      if (!file.length) {
        return;
      }

      const formData = new FormData();
      Array.from(Array(file.length).keys()).map((x) => {
        formData.append(name, file[x], file[x].name);
        if (file[x].size / 1024 / 1024 <= 2) {
          switch (index) {
            case 0:
              this.files[index].content = file[x];
              this.$emit("updateFiles", this.files[index].content, 0);
              break;
            case 1:
              this.files[index].content = file[x];
              this.$emit("updateFiles", this.files[index].content, 1);
              break;
            case 2:
              this.files[index].content = file[x];
              this.$emit("updateFiles", this.files[index].content, 2);
              break;
          }
        } else {
          this.overSize = true;
        }
      });
    },

    deleteFile(index) {
      if (!this.$refs['attachment-' + index][0]) {
        return;
      }

      this.$refs['attachment-' + index][0].value = "";
      switch (index) {
        case 0:
          this.files[index].content = "";
          this.$emit("updateFiles", this.files[index].content, 0);
          break;
        case 1:
          this.files[index].content = "";
          this.$emit("updateFiles", this.files[index].content, 1);
          break;
        case 2:
          this.files[index].content = "";
          this.$emit("updateFiles", this.files[index].content, 2);
          break;
      }
    },

    handleUploadImage(value) {
      if (!value || !value.files || value.files.length <= 0) {
        return;
      }

      let file = value.files;
      this.extentionError = false;
      this.overSize = false;
      const formData = new FormData();
      Array.from(Array(file.length).keys()).map((x) => {
        formData.append("", file[x], file[x].name);
        if (!file[x].name) {
          this.extentionError = true;
          return;
        }
        if (!IMAGE_EXTENTIONS.includes(file[x].name.toLowerCase().split('.').pop())) {
          this.extentionError = true;
          return;
        }

        if (file[x].size / 1024 / 1024 > 2) {
          this.overSize = true;
          return;
        }

        this.file = file[x];
        this.$emit("updatePhoto", this.file);
      });
    },

    handleDeleteImage() {
      this.$refs.fileupload.value = "";
      this.file = "";
      this.$emit("updatePhoto", this.file);
    },

    setYearToDefaultValue(resource, value) {
      this.birthDate.setYear(value);
      resource.default_value = this.birthDate.toString();
    },

    setMonthToDefaultValue(resource, value) {
      this.birthDate.setMonth(value - 1);
      resource.default_value = this.birthDate.toString();
    },

    setDateToDefaultValue(resource, value) {
      this.birthDate.setDate(value);
      resource.default_value = this.birthDate.toString();
    },

    checkInputPhone(isItemJob, resource) {
      resource.wrongPhone = false;
      resource.isWrongValue = false;
      resource.isMinLengthError = false;
      resource.isMaxLengthError = false;
      resource.isWrongFormat = false;
      if(isItemJob || resource.default_value.trim().length === 0){
        this.$emit("updateCheckErrorInput", resource);
        return;
      }

      let isAvailableValue = true;
      let countNumber = 0;
      for (let i = 0; i < resource.default_value.length; i++) {
        let char = resource.default_value.charAt(i);
        if (char === "-" || char === " " || char === "+") {
          continue;
        }

        if (this.isNumber(char)) {
          countNumber++;
        } else {
          isAvailableValue = false;
          break;
        }
      }

      if (!isAvailableValue || countNumber < 10 || countNumber > 20) {
        resource.wrongPhone = true;
        resource.isWrongFormat = true;
      }

      this.validateStringLengthInput(isItemJob, resource);
    },

    isNumber(n) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    },

    checkInputURL(isItemJob, resource) {
      resource.wrongUrl = false;
      resource.isWrongValue = false;
      resource.isMinLengthError = false;
      resource.isMaxLengthError = false;
      resource.isWrongFormat = false;
      if(isItemJob || resource.default_value.trim().length === 0){
        this.$emit("updateCheckErrorInput", resource);
        return;
      }
      if (!(resource.default_value.startsWith("http://") || resource.default_value.startsWith("https://"))) {
        resource.wrongUrl = true;
        resource.isWrongFormat = true;
      }
      this.validateStringLengthInput(isItemJob, resource);
    },

    checkInputEmail(isItemJob, resource) {
      resource.wrongEmail = false;
      resource.isWrongValue = false;
      resource.isMinLengthError = false;
      resource.isMaxLengthError = false;
      resource.isWrongFormat = false;
      if(isItemJob || resource.default_value.trim().length === 0){
        this.$emit("updateCheckErrorInput", resource);
        return;
      }
      const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regexEmail.test(resource.default_value)) {
        resource.wrongEmail = true;
        resource.isWrongFormat = true;
      }
      this.validateStringLengthInput(isItemJob, resource);
    },

    validateStringLengthInput(isItemJob, resource) {
      resource.isMinLengthError = false;
      resource.isMaxLengthError = false;
      resource.isWrongValue = false;
      if(isItemJob || resource.default_value.trim().length === 0){
        this.$emit("updateCheckErrorInput", resource);
        return;
      }
      let lengthInput = resource.default_value.length;
      if(resource.min_length){
        resource.isMinLengthError = lengthInput < resource.min_length;
      }
      if(resource.max_length){
        resource.isMaxLengthError = lengthInput > resource.max_length;
      }
      if(!resource.max_length && (resource.type === "text" && lengthInput > messagesProperties.MAX_LENGTH_INPUT_TEXT) || (resource.type === "textarea" && lengthInput > messagesProperties.MAX_LENGTH_INPUT_TEXT_AREA)){
        resource.isMaxLengthError = true;
      }
      resource.isWrongValue = resource.isMinLengthError || resource.isMaxLengthError;
      this.$emit("updateCheckErrorInput", resource);
    },

    validateNumberInput(isItemJob, resource) {
      resource.isMinNumberError = false;
      resource.isMaxNumberError = false;
      resource.isWrongValue = false;
      resource.isWrongDecimalPoint = false;
      if(isItemJob || resource.default_value.length === 0){
        this.$emit("updateCheckErrorInput", resource);
        return;
      }
      let numberInput = Number(resource.default_value);
      if(resource.min_length){
        resource.isMinNumberError = numberInput < resource.min_length;
      }
      if(resource.max_length){
        resource.isMaxNumberError = numberInput > resource.max_length;
      }
      resource.isWrongValue = resource.isMinNumberError || resource.isMaxNumberError;
      if(resource.default_value && resource.step && this.labelsProperties.TYPE_OF_NUMBERIC.includes(resource.type)){
        resource.step = String(resource.step);
        resource.default_value = String(resource.default_value);
        let steps = resource.step.split('.');
        let values = resource.default_value.split('.');

        if(resource.step === "1" && values.length > 1){
          resource.isWrongDecimalPoint = true;
          resource.length_step = 0;
        }else if(steps.length > 1 && values.length > 1){
          resource.length_step = steps[1].length;
          resource.isWrongDecimalPoint = values[1].length > steps[1].length ? true: false;
        }
      }
      this.$emit("updateCheckErrorInput", resource);
    },

    checkTypeOfArray(resource) {
      if (!Array.isArray(resource.default_value)) {
        resource.default_value = [];
      }

      return resource;
    },
  },
};
</script>

<style>
.wrong-input {
  color: red;
}

.input-date {
  width: 100px !important;
  flex: none !important;
}

.option-class {
  width: 250px !important;
}

.setting_form_radio_label
input[type="radio"]:disabled
+ .setting_form_radio_text::before {
  background-color: #f0c7aa;
}

.disabled-setting input:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.disabled-setting input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #ffffff;
}

.setting_form_select:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.setting_form_select {
  background: #ffffff;
}

.entry_uploader_item {
  padding-bottom: unset !important;
}

.img_label {
  margin-left: 13px;
}

.setting_form_text_customize,
.setting_form_textarea {
  background-color: #fff !important;
}

.setting_form_text_customize {
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 16px;
  min-height: 32px;
  width: 100%;
}

.setting_form_input_from_to {
  display: flex;
}

.date_form_join_string {
  flex-grow: 0;
  margin: 5px 10px;
}

.mx-table-date .today {
  background-color: #feffce !important;
  color: rgb(7, 7, 7) !important;
}

.mx-calendar-content .cell.active {
  color: #fff !important;
  background-color: #db8f57 !important;
}

.mx-input:hover,
.mx-input:focus {
  border-color: #ced4da !important;
}

.mx-datepicker {
  width: 100% !important;
}

.mx-calendar-content .cell:hover {
  color: #000000;
  background-color: #feffce !important;
}

.mx-time-column .mx-time-item.active {
  background-color: #feffce !important;
  color: rgb(7, 7, 7) !important;
}

.label_unit_item {
  word-break: keep-all;
}

.label_unit_item_long {
  word-break: break-all !important;
  min-width: 50px;
}

.jobs_table_form_unit > * + * {
  margin-left: 5px;
}

.mx-input {
  width: 100%;
  background-color: #fff !important;
  padding: 8px;
  font-size: 16px;
  min-height: 32px;
}

.mx-input::-moz-placeholder {
  color: #ccc;
}

.mx-input:-ms-input-placeholder {
  color: #ccc;
}

.mx-input::placeholder {
  color: #ccc;
}

.mx-input::-webkit-input-placeholder {
  color: #ccc;
}

.mx-input:-ms-input-placeholder {
  color: #ccc;
}

.mx-input::-ms-input-placeholder {
  color: #ccc;
}

.mx-input::-moz-placeholder {
  color: #ccc;
}
</style>
